module.exports = __webpack_public_path__ + "img/Motorcycle.f3b59653.png";